export enum UserCategory {
  INTERNAL = "internal",
  HIREABLE = "hireable",
  CLIENT   = "client",
}

export const UserTypeEnum = {
  UNKNOWN       : "unknown",
  DEV           : "dev",
  PM            : "pm",
  QA            : "qa",
  UX_UI_DESIGNER: "ux_ui_designer",
  DEVOPS        : "devops",
  REGULAR       : "regular",
  ADMIN         : "admin",
  INTERNAL      : "internal",
  FINANCE       : "finance",
} as const;

export type UserType = (typeof UserTypeEnum)[keyof typeof UserTypeEnum];

export type IRole = {
  id  : number;
  role: UserType;
}

export type IGetAdminRolesResponse = {} & IRole 